import { render } from "./currencysettings.vue?vue&type=template&id=4f68d022"
import script from "./currencysettings.vue?vue&type=script&lang=js"
export * from "./currencysettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__